import { useState, useCallback } from 'react';

type VariantType = 'success' | 'error' | 'info';

export interface IMessageState {
  isOpened: boolean;
  message: string;
  variant: VariantType;
}

export type GlobalMessageHookResponse = [IMessageState, (message: string, variant?: VariantType) => void, () => void];

const initialState: IMessageState = {
  isOpened: false,
  message: '',
  variant: 'success',
};

export const useGlobalMessage = (): GlobalMessageHookResponse => {
  const [messageState, setMessageState] = useState(initialState);

  const showMessage = useCallback((message: string, variant: VariantType = 'success'): void => {
    setMessageState({
      ...initialState,
      isOpened: true,
      message,
      variant,
    });
  }, []);

  const hideMessage = useCallback(() => setMessageState(initialState), []);

  return [messageState, showMessage, hideMessage];
};
